var trigger = document.getElementById("js-search-trigger");
var searchform = document.getElementById("js-searchform");
var searchfield = document.getElementById("q");
var searchnavitem = document.getElementById("js-search-nav-item");

// Add up element attributes for accessibility
function initSearch() {
    var translation = trigger.dataset.translation;

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-label', translation);
    trigger.setAttribute('aria-controls', 'js-searchform');
    trigger.setAttribute('aria-expanded', 'false');
}

// Show / Hides search panel
function toggleSearch(event) {
    event.preventDefault();

    if (searchform.classList.contains('is-visible')) {
        trigger.setAttribute('aria-expanded', 'false');
    } else {
        trigger.setAttribute('aria-expanded', 'true');
    }

    searchform.classList.toggle("is-visible");
    searchnavitem.classList.toggle("c-header__nav-item--current");
    searchfield.focus();
}

trigger.onclick = toggleSearch;
onReady.callbacks.search = initSearch;
